import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {lazyInject} from "@/container";
import {TYPES} from "@/types";
import {SceneService} from "@/services/scene-service";
import SceneUtils from "@/utils/scene-utils";
import {Creature} from "@/store/level/types";
import {LoadUtils, LoaderState} from "@/utils/load-utils";
import PlayerStore from "@/store/player";
import {Lang} from "@/store/player/types";
import {Settings} from "@/constants/settings";
import {IntegrationUtils} from "@/utils/integration-utils";
import {Gender} from "@/model/gender";
import PlayerUtils from "@/utils/player-utils";
import ArtifactUtils from "@/utils/artifact-utils";
import PlaceStore from "@/store/place";
import AnimationUtils from "@/utils/animation-utils";
import {Urls} from "@/constants/urls";
import {Version} from "@/constants/version";
import {Reloadable} from "@/scenes/reloadable";
import {SceneName} from "@/model/scene-name";

export default class BootScene extends Scene implements Reloadable {

  @lazyInject(TYPES.SceneService)
  private sceneService!: SceneService;

  private canvas!: HTMLCanvasElement;

  constructor() {
    super({ key: 'BootScene' });
  }

  public preload(): void {
    this.load.bitmapFont(Keys.BM_COINY, 'assets/bmFonts/Coiny/Coiny.png', 'assets/bmFonts/Coiny/Coiny.xml');

    PlayerStore.logLoadBoot();
    this.canvas = this.sys.game.canvas;

    // this.load.addListener(Phaser.Loader.Events.FILE_LOAD_ERROR, (err: any) => {
    //   LoadFixer.LOAD_ERRORS.push(err)
    //   BootScene.RELOAD = true;
    // });
  }

   private loaderState = new LoaderState();

  public update(time: number, delta: number) {
    this.loaderState.update(time, delta);
  }

  public create(): void {

    LoadUtils.showLoadingScreen(this, this.canvas, this.loaderState);
    SceneUtils.setCurrentScene(this);

    console.log("V 1." + Version.VERSION_NUM);

    //@ts-ignore
    window.phgame = this.scene.scene.game;

    let player = PlayerStore.getPlayer();
    if (player && player.creatures) {
      player.creatures.forEach((c: Creature) => {
        this.load.image(Keys.profileCreature(c.imageId), `assets/profile/creatures/${c.imageId}.png`);
      });
    } else {
      for (let creature of Keys.PROFILE_CREATURES) {
        this.load.image(Keys.profileCreature(creature), `assets/profile/creatures/${creature}.png`);
      }
    }

    this.load.image(Keys.BIG_CAT_MALE, 'assets/creatures/cat_m.png');
    this.load.image(Keys.BIG_CAT_FEMALE, 'assets/creatures/cat_f.png');
    this.load.image(Keys.IMG_CHAR_SELECTION_BACKGROUND, 'assets/character_selection/forest_background.jpg');

    this.load.image(Keys.IMG_CHAR_SELECTION_WINDOW, 'assets/character_selection/select_char_window.png');

    this.load.image(Keys.UI_LANG_BUTT, 'assets/character_selection/lang_butt.png');
    this.load.image(Keys.UI_LANG_ACC_BUTT, 'assets/character_selection/lang_acc_butt.png');

    this.load.image(Keys.UI_LANG_BUTT_AVAL, 'assets/character_selection/lang_aval.png');
    this.load.image(Keys.UI_LANG_BUTT_UNAVAL, 'assets/character_selection/lang_unaval.png');

    this.load.image(Keys.UI_LOGIN_BUTT, 'assets/character_selection/login_butt.png');
    this.load.image(Keys.UI_LOGIN_BUTT_BG, 'assets/character_selection/login_butt_bg.png');

    this.load.image(Keys.EDU_BLACKOUT, 'assets/edu/blackout.png');

    this.load.image(Keys.CLOUD, 'assets/cloud.png');
    this.load.image(Keys.CLOUD2, 'assets/cloud2.png');

    this.load.image(Keys.IMG_RES_GOLD, 'assets/loot/res_gold.png');
    this.load.image(Keys.IMG_RES_GOLD_NO_SHADOW, 'assets/loot/res_gold_no_shadow.png');
    this.load.image(Keys.IMG_RES_CRYSTAL, 'assets/loot/res_crystal_red.png');
    this.load.image(Keys.IMG_RES_ELIXIR, 'assets/loot/res_crystal_yellow.png');
    this.load.image(Keys.IMG_RES_ELIXIR_NO_SHADOW, 'assets/loot/res_crystal_yellow_no_shadow.png');
    this.load.image(Keys.IMG_RES_MITHRIL, 'assets/loot/res_gem.png');
    this.load.image(Keys.IMG_RES_SULFUR, 'assets/loot/res_sulfur.png');
    this.load.image(Keys.IMG_RES_CAVIAR, 'assets/loot/res_caviar.png');
    this.load.image(Keys.IMG_RES_GEM_NO_SHADOW, 'assets/loot/gem_no_shadow.png');

    this.load.image(Keys.IMG_VICTORY_KNIGHT, 'assets/ui/victory_knight.png');
    this.load.image(Keys.IMG_TICKET, 'assets/ui/ticket.png');
    this.load.image(Keys.IMG_TICKET_BIG, 'assets/ui/ticket_big.png');
    this.load.image(Keys.IMG_GREEN_DOT, 'assets/ui/green_dot.png');
    this.load.image(Keys.IMG_YELLOW_DOT, 'assets/ui/yellow_dot.png');
    this.load.image(Keys.IMG_WHITE_SWORD, 'assets/ui/white_sword.png');
    this.load.image(Keys.IMG_WHITE_HEART, 'assets/ui/white_heart.png');
    this.load.image(Keys.IMG_WHITE_SHIELD, 'assets/ui/white_shield.png');
    this.load.image(Keys.IMG_DIALOG_BUBBLE, 'assets/ui/dialog_bubble.png');
    this.load.image(Keys.IMG_SNOW, 'assets/particles/snow.png');
    this.load.image(Keys.IMG_SPARK1, 'assets/particles/spark1.png');
    this.load.image(Keys.IMG_SPARK2, 'assets/particles/spark2.png');
    this.load.image(Keys.IMG_SPARK3, 'assets/particles/spark3.png');

    for (let anim of Keys.ANIMS) {
        if (anim === Keys.LOADING_ANIM) {
            continue;
        }
        let size = AnimationUtils.getFrameSize(anim);
        this.load.spritesheet(anim, `assets/anim/${anim}.png`, { frameWidth: size.x, frameHeight: size.y });
    }

    this.load.atlas(Keys.ATLAS_UI_2, `assets/ui${Urls.CURRENT_UI_STYLE}/ui2${Urls.CURRENT_UI_STYLE}.png`, `assets/ui/ui2.json`);

    LoadUtils.loadAtlas(this, Keys.ATLAS_EDU);
    LoadUtils.loadImage(this, Keys.HEROES_COMMENT);
    LoadUtils.loadImage(this, Keys.HEROES_COMMENT_2);
    LoadUtils.loadImage(this, Keys.HEROES_COMMENT_3);
    LoadUtils.loadImage(this, 'rab-edu');
    LoadUtils.loadImage(this, Keys.ROADS_START);
    LoadUtils.loadImage(this, Keys.ROADS_START_2);
    LoadUtils.loadImage(this, Keys.IC_100_MITHRIL);
    LoadUtils.loadAtlas(this, Keys.ATLAS_UI);
    LoadUtils.loadAtlas(this, Keys.ATLAS_PROFILE);

    LoadUtils.loadAtlas(this, Keys.ATLAS_SHOP_UI);

    LoadUtils.loadImage(this, Keys.IMG_LESSON_HAND_SHADOW);
    LoadUtils.loadImage(this, Keys.IMG_LESSON_HAND);
    LoadUtils.loadImage(this, Keys.IMG_BLACK_BACKGROUND);

    LoadUtils.loadImage(this, Keys.IMG_PARTICLE_CIRCLE);
    LoadUtils.loadImage(this, Keys.PLACE_SHADOW);
    LoadUtils.loadImage(this, Keys.IMG_CLICK_FLASH);
    LoadUtils.loadImage(this, Keys.IMG_CROSSHAIR);
    LoadUtils.loadAtlas(this, Keys.ATLAS_CREATURES_ROAD);
    LoadUtils.loadAtlas(this, Keys.ATLAS_PLACES_1);

    LoadUtils.loadImage(this, Keys.UI_WINDOW_HORIZONTAL);
    LoadUtils.loadImage(this, Keys.UI_WINDOW_MIDDLE);
    LoadUtils.loadImage(this, Keys.UI_WINDOW_MIDDLE_BIG);
    LoadUtils.loadImage(this, Keys.IMG_VICTORY_KNIGHT);
    LoadUtils.loadImage(this, Keys.IMG_CARD_SHADE);
    LoadUtils.loadImage(this, Keys.BRIDGE);
    LoadUtils.loadImage(this, Keys.IC_100_MITHRIL);

    LoadUtils.loadBattleMusic(this);
    ArtifactUtils.loadArtifacts(this);

    LoadUtils.loadAtlas(this, Keys.ATLAS_LEAGUE_SMALL);
    LoadUtils.loadImage(this, Keys.IMG_SKULL_ICON);
    LoadUtils.loadImage(this, Keys.IMG_GREY_BACKGROUND);
    LoadUtils.loadImage(this, Keys.IMG_PLAYER_TURN);
    LoadUtils.loadImage(this, Keys.IMG_REWARD_EXPERIENCE);
    LoadUtils.loadImage(this, Keys.CL_GEAR_RESOURCE);
    LoadUtils.loadImage(this, Keys.IMG_REWARD_CUPS);
    LoadUtils.loadImage(this, Keys.IMG_REWARD_GEM);
    LoadUtils.loadImage(this, Keys.IMG_REWARD_CRYSTAL_RED);
    LoadUtils.loadImage(this, Keys.IMG_REWARD_GOLD);
    LoadUtils.loadImage(this, Keys.IMG_REWARD_CRYSTAL_YELLOW);
    LoadUtils.loadImage(this, Keys.UI_POWER_UP_INFO_MIDDLE);

    LoadUtils.loadCampaignDepending(this, player);

    if (Settings.LANG_TYPE === Lang.RU) {
      LoadUtils.loadImage(this, Keys.RAB_RU);
    } else {
      LoadUtils.loadImage(this, Keys.RAB_EN);
    }

    if (!player) {
      this.load.spritesheet(Keys.ANIM_KNIGHT_WALK_M, 'assets/anim/knight_walk_m.png', {
        frameWidth: 75.4,
        frameHeight: 187.5
      });
      this.load.spritesheet(Keys.ANIM_KNIGHT_IDLE_M, 'assets/anim/knight_idle_m.png', {
        frameWidth: 101.5,
        frameHeight: 174.25
      });

      this.load.spritesheet(Keys.ANIM_KNIGHT_IDLE_W, 'assets/anim/knight_idle_w.png', {
        frameWidth: 101.5,
        frameHeight: 174.25
      });
      this.load.spritesheet(Keys.ANIM_KNIGHT_WALK_W, 'assets/anim/knight_walk_w.png', {
        frameWidth: 75.4,
        frameHeight: 187
      });

      this.load.spritesheet(Keys.STAIRS_YELLOW[0], 'assets/stair/yellow_s0.png', { frameWidth: 33, frameHeight: 16 });
      this.load.spritesheet(Keys.STAIRS_GREEN[0], 'assets/stair/green_s0.png', { frameWidth: 33, frameHeight: 16 });
      this.load.spritesheet(Keys.STAIRS_RED[0], 'assets/stair/red_s0.png', { frameWidth: 33, frameHeight: 16 });

      LoadUtils.loadAtlas(this, Keys.ATLAS_CREATURES_BATTLE_0);

    } else {
      let gender: Gender = PlayerUtils.getGender(player);
      switch (gender) {
        case Gender.male:
          this.load.spritesheet(Keys.ANIM_KNIGHT_WALK_M, 'assets/anim/knight_walk_m.png', {
            frameWidth: 75.4,
            frameHeight: 187.5
          });
          this.load.spritesheet(Keys.ANIM_KNIGHT_IDLE_M, 'assets/anim/knight_idle_m.png', {
            frameWidth: 101.5,
            frameHeight: 174.25
          });
          break;
        case Gender.female:
          this.load.spritesheet(Keys.ANIM_KNIGHT_IDLE_W, 'assets/anim/knight_idle_w.png', {
            frameWidth: 101.5,
            frameHeight: 174.25
          });
          this.load.spritesheet(Keys.ANIM_KNIGHT_WALK_W, 'assets/anim/knight_walk_w.png', {
            frameWidth: 75.4,
            frameHeight: 187
          });
          break;
      }

      LoadUtils.loadImage(this, Keys.UI_WINDOW_HORIZONTAL);
      LoadUtils.loadImage(this, Keys.UI_WINDOW_MIDDLE);
      LoadUtils.loadImage(this, Keys.UI_WINDOW_MIDDLE_BIG);
      LoadUtils.loadAtlas(this, Keys.ATLAS_CREATURES_BATTLE_1);
      LoadUtils.loadAtlas(this, Keys.ATLAS_FORCES);
      LoadUtils.loadAtlas(this, Keys.ATLAS_FORCES_BIG);

      for (let tile of PlaceStore.getTiles()) {
        LoadUtils.loadImage(this, tile.textureKey);
      }

      let stairTextsCount = Math.floor((player.stair + 150) / 100);
      for (let i = 0; i < stairTextsCount; ++i) {
        if (i > 24) {
          break;
        }
        this.load.spritesheet(Keys.STAIRS_YELLOW[i], 'assets/stair/yellow_s' + i + '.png', { frameWidth: 33, frameHeight: 16 });
        this.load.spritesheet(Keys.STAIRS_GREEN[i], 'assets/stair/green_s' + i + '.png', { frameWidth: 33, frameHeight: 16 });
        this.load.spritesheet(Keys.STAIRS_RED[i], 'assets/stair/red_s' + i + '.png', { frameWidth: 33, frameHeight: 16 });
      }

      if (player.stair > 60) {
        LoadUtils.loadAtlas(this, Keys.ATLAS_CREATURES_BATTLE_2);
        LoadUtils.loadAtlas(this, Keys.ATLAS_PLACES_2);
        LoadUtils.loadAtlas(this, Keys.ATLAS_PLACES_3);
        LoadUtils.loadAtlas(this, Keys.ATLAS_CREATURES_ROAD_2);
        LoadUtils.loadAtlas(this, Keys.ATLAS_FORCES_2);
        LoadUtils.loadAtlas(this, Keys.ATLAS_FORCES_BIG_2);
      }

      if (player.stair > 250) {
        LoadUtils.loadAtlas(this, Keys.ATLAS_PLACES_4);
        LoadUtils.loadAtlas(this, Keys.ATLAS_CREATURES_BATTLE_4);
        LoadUtils.loadAtlas(this, Keys.ATLAS_CREATURES_ROAD_4);
      }

      if (player.stair > 450) {
        LoadUtils.loadAtlas(this, Keys.ATLAS_CREATURES_BATTLE_5);
        LoadUtils.loadAtlas(this, Keys.ATLAS_CREATURES_ROAD_5);
        LoadUtils.loadImage(this, Keys.ENEMY_LEV_5);
        LoadUtils.loadAtlas(this, Keys.ATLAS_FORCES_5);
        LoadUtils.loadAtlas(this, Keys.ATLAS_FORCES_BIG_5);
      }

      if (player.stair > 975) {
        LoadUtils.loadAtlas(this, Keys.ATLAS_CREATURES_ROAD_8);
        // LoadUtils.loadAtlas(this, Keys.ATLAS_FORCES_6);
        // LoadUtils.loadAtlas(this, Keys.ATLAS_FORCES_BIG_6);
        // LoadUtils.loadAtlas(this, Keys.ATLAS_FORCES_LARGE_6);
        // LoadUtils.loadAtlas(this, Keys.ATLAS_FORCES_SEMI_LARGE_6);
      }

      if (player.stair > 400) {
        LoadUtils.loadAtlas(this, Keys.ATLAS_PLACES_5);
      }

    }

    TextUtils.setupCustomFonts();

    LoadUtils.loadMusic(this, player);

    let size = AnimationUtils.getFrameSize(Keys.LOADING_ANIM);
    this.load.spritesheet(Keys.LOADING_ANIM, `assets/anim/${Keys.LOADING_ANIM}.png`, { frameWidth: size.x, frameHeight: size.y });

    this.load.start();

    this.load.once(Phaser.Loader.Events.COMPLETE, () => {
      PlayerStore.logLoadCompleted();
      if (IntegrationUtils.isCrazyUser()) {
        // @ts-ignore
        window.CrazyGames.SDK.game.loadingStop();
        // @ts-ignore
        window.CrazyGames.SDK.game.gameplayStart();
      }
      LoadUtils.goToNewSceneAfterLoad(this, this.sceneService);
    });
  }

  public reload(): void {
    window.location.reload();
  }
}
